import { render, staticRenderFns } from "./ReviewReportScreen.vue?vue&type=template&id=77cc61e2&"
import script from "./ReviewReportScreen.vue?vue&type=script&lang=ts&"
export * from "./ReviewReportScreen.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewReportScreen.vue?vue&type=style&index=0&id=77cc61e2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports